import React from 'react';

interface IPlusIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const PlusIcon: React.FC<IPlusIconProps> = ({ color = '#6E6E6E', className, ...rest }) => {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path d="M6 8H0V6H6V0H8V6H14V8H8V14H6V8Z" fill={color} />
    </svg>
  );
};

export default PlusIcon;
